import type { PaymentDetail, PaymentListItem } from '@pet/shared';
import { ReceiptApiError } from './receiptClient';

// Re-export so read screens can catch a single error type without reaching into
// receiptClient, matching paymentClient.ts.
export { ReceiptApiError };

async function extractErrorMessage(res: Response): Promise<string> {
  try {
    const body = (await res.json()) as { error?: string };
    return body.error ?? `HTTP ${res.status}`;
  } catch {
    return `HTTP ${res.status}`;
  }
}

export async function getPayments(): Promise<PaymentListItem[]> {
  const res = await fetch('/api/payments', { credentials: 'include' });
  if (!res.ok) {
    throw new ReceiptApiError(res.status, await extractErrorMessage(res));
  }
  const data = (await res.json()) as { payments: PaymentListItem[] };
  return data.payments;
}

export async function getPayment(id: string): Promise<PaymentDetail> {
  const res = await fetch(`/api/payments/${encodeURIComponent(id)}`, {
    credentials: 'include',
  });
  if (!res.ok) {
    throw new ReceiptApiError(res.status, await extractErrorMessage(res));
  }
  const data = (await res.json()) as { payment: PaymentDetail };
  return data.payment;
}
